export default {
  install(Vue) {
    Vue.prototype.errorHandler = console.log;
  },
};
